import { keyframes } from '@chakra-ui/react';

const transform = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;

export const spin = (speed = '0.45s'): string =>
  `${transform} ${speed} linear infinite`;
